import script from "./FbaStorageFeesView.vue?vue&type=script&setup=true&lang=js"
export * from "./FbaStorageFeesView.vue?vue&type=script&setup=true&lang=js"

import "./FbaStorageFeesView.vue?vue&type=style&index=0&id=a65dd22c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a65dd22c"]])

export default __exports__